'use client';

import { ArrowUpRight } from 'lucide-react';

export function AIAssistantButton({ className }: { className?: string }) {
  return (
    <button 
      onClick={() => window.dispatchEvent(new Event('open-ai-assistant'))}
      className={className || "inline-flex items-center gap-3 px-8 py-3 rounded-full bg-primary text-white font-black text-sm uppercase tracking-widest hover:shadow-[0_0_30px_rgba(var(--primary),0.4)] transition-all"}
    >
       Open AI Assistant <ArrowUpRight className="h-4 w-4" />
    </button>
  );
}
